// Enhanced keyboard accessibility for dropdown menus
export function initDropdowns() {
    const dropdowns = document.querySelectorAll('.dropdown-container');

    dropdowns.forEach((dropdown) => {
        const trigger = dropdown.querySelector<HTMLElement>('.dropdown-trigger');
        const menu = dropdown.querySelector<HTMLElement>('.dropdown-menu');

        if (!trigger || !menu) return;

        const menuItems = menu.querySelectorAll<HTMLAnchorElement>('a');
        const isClickDriven = dropdown.classList.contains('click-dropdown');

        // Click-driven dropdown (like topics-dropdown)
        if (isClickDriven) {
            const dropdownTitle = trigger.querySelector('.dropdown-title');

            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                console.log('Initializing click-driven dropdown', dropdown);

                const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

                // Close all other dropdowns
                document.querySelectorAll('.click-dropdown .dropdown-trigger').forEach((otherTrigger) => {
                    if (otherTrigger !== trigger) {
                        otherTrigger.setAttribute('aria-expanded', 'false');
                        const otherMenu = otherTrigger.parentElement?.querySelector('.dropdown-menu') as HTMLElement;
                        if (otherMenu) {
                            otherMenu.classList.add('hidden');
                            otherMenu.classList.remove('grid', 'opacity-100');
                        }
                    }
                });

                trigger.setAttribute('aria-expanded', String(!isExpanded));

                if (!isExpanded) {
                    // menu.classList.remove('hidden');
                    menu.classList.add('active');
                } else {
                    menu.classList.remove('active');
                }
            });

            // Handle menu item clicks
            menuItems.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();

                    // Update dropdown title with selected text
                    if (dropdownTitle) {
                        dropdownTitle.textContent = item.textContent;
                    }

                    // Close the dropdown
                    trigger.setAttribute('aria-expanded', 'false');
                    menu.classList.remove('active');

                    // Navigate to the link
                    window.location.href = item.href;
                });
            });

            // Close dropdown when clicking outside
            document.addEventListener('click', (e) => {
                const target = e.target as HTMLElement;
                if (!dropdown.contains(target)) {
                    trigger.setAttribute('aria-expanded', 'false');
                    menu.classList.remove('active');
                }
            });
        } else {
            // Hover-driven dropdown (default)
            dropdown.addEventListener('mouseenter', () => {
                trigger.setAttribute('aria-expanded', 'true');
            });

            dropdown.addEventListener('mouseleave', () => {
                trigger.setAttribute('aria-expanded', 'false');
            });
        }

        // Keyboard navigation (for both types)
        trigger.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
                trigger.setAttribute('aria-expanded', String(!isExpanded));

                if (!isExpanded) {
                    menu.classList.remove('hidden');
                    menu.classList.add(isClickDriven ? 'grid' : 'grid', 'opacity-100');
                    menuItems[0]?.focus();
                } else {
                    menu.classList.add('hidden');
                    menu.classList.remove(isClickDriven ? 'grid' : 'grid', 'opacity-100');
                }
            }

            if (e.key === 'Escape') {
                trigger.setAttribute('aria-expanded', 'false');
                menu.classList.add('hidden');
                menu.classList.remove(isClickDriven ? 'grid' : 'grid', 'opacity-100');
                trigger.focus();
            }
        });

        // Handle escape key for menu items
        menuItems.forEach((item, index) => {
            item.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key === 'Escape') {
                    trigger.setAttribute('aria-expanded', 'false');
                    menu.classList.add('hidden');
                    menu.classList.remove(isClickDriven ? 'grid' : 'grid', 'opacity-100');
                    trigger.focus();
                }

                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const nextItem = menuItems[index + 1];
                    if (nextItem) {
                        nextItem.focus();
                    } else {
                        menuItems[0]?.focus();
                    }
                }

                if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    const prevItem = menuItems[index - 1];
                    if (prevItem) {
                        prevItem.focus();
                    } else {
                        menuItems[menuItems.length - 1]?.focus();
                    }
                }
            });
        });
    });
}
